module.exports = __webpack_public_path__ + "img/cc31ac6.png";